// extracted by mini-css-extract-plugin
export default {"container":"SystemNotifications_container__v6CXD","notification":"SystemNotifications_notification__T5aC0"};